import { useQuery } from '@tanstack/react-query';
import getGiveawayList from 'Api/brief-live/getGiveawayList';
import getGiveawayListRequest from './model/request/getGiveawayListRequest';
import getGiveawayListResponse from './model/response/getGiveawayListResponse';

const useGetGiveawayList = ({ queryParams, enabled = true }) => {
  return useQuery({
    queryKey: ['giveaway-list', queryParams],
    queryFn: async () => {
      const queries = getGiveawayListRequest(queryParams);

      const response = await getGiveawayList(queries);

      const result = getGiveawayListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetGiveawayList;
